import { useEffect } from 'react';

import { configureSharedDCCTVolumeSize } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { useAppSelector } from '@/shared/hooks';

import { selectDCCTVolumeState } from '../model/mpr.selectors';

// The file size comes from the asset record, so the engine never has to probe for it.
// That turns the volume open into one round trip of two concurrent explicit byte
// ranges: a suffix range would need a CORS preflight and a store that exposes
// Content-Range. Must run before anything opens the volume, hence page level.
export const useDCCTVolumeSizeHint = ({
  patientID,
  reportID,
}: {
  patientID: string;
  reportID: string;
}) => {
  const { volumeFileID, volumeFileSizeBytes } = useAppSelector(
    selectDCCTVolumeState({ patientID, reportID }),
  );

  useEffect(() => {
    if (!volumeFileID || !volumeFileSizeBytes) {
      return;
    }

    configureSharedDCCTVolumeSize({
      fileID: volumeFileID,
      sizeBytes: volumeFileSizeBytes,
    });
  }, [volumeFileID, volumeFileSizeBytes]);
};
